import React, { useCallback, useEffect, useRef, useState } from 'react'
import cx from 'classnames'
import useManageWatchlist from './hooks/useManageWatchlist'
import FocusableButtonTS from '../../FocusableButton/FocusableButtonTS'
import { MyListIcon, CheckmarkIcon } from '../../Icons'
import { ContentActionButtonFocusKeys, ContentActionButtonLabel } from './types'
import { ButtonProps } from '../types'

function MyList(props: ButtonProps) {
  const [isFocused, setIsFocused] = useState(false)
  const { removeFromWatchlist, addToWatchlist, inWatchlist } =
    useManageWatchlist()

  const latestActionRef = useRef(
    inWatchlist ? removeFromWatchlist : addToWatchlist
  )

  useEffect(() => {
    latestActionRef.current = inWatchlist ? removeFromWatchlist : addToWatchlist
  }, [inWatchlist, removeFromWatchlist, addToWatchlist])

  const handleEnterPress = useCallback(() => {
    latestActionRef.current?.()
    props.onPress(ContentActionButtonLabel.MY_LIST)
  }, [])

  const onFocus = () => {
    setIsFocused(true)
    props.onFocus({
      label: ContentActionButtonLabel.MY_LIST,
    })
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  return (
    <div className="video-detail-screen__control-button">
      <FocusableButtonTS
        focusKey={ContentActionButtonFocusKeys.MY_LIST}
        onEnterPress={handleEnterPress}
        onArrowPress={props.onArrowPress}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {inWatchlist ? <CheckmarkIcon /> : <MyListIcon />}
      </FocusableButtonTS>
      <span
        className={cx('video-detail-screen__control-button-label', {
          'video-detail-screen__control-button-label--focused': isFocused,
        })}
      >
        {ContentActionButtonLabel.MY_LIST}
      </span>
    </div>
  )
}

export default MyList
